module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_moere_og_romsdal_pos.2ff0dc4f.svg";